import { FC } from "react";
import { Controller } from "react-hook-form";

export const RsvpFormMessage: FC = () => {
  return (
    <Controller
      name="message"
      render={({
        field: { onChange, onBlur },
        formState: { isSubmitting },
      }) => {
        return (
          <div className="form-floating">
            <textarea
              disabled={isSubmitting}
              onChange={onChange}
              onBlur={onBlur}
              id="message"
              name="Message"
              placeholder="Message"
              className="form-control"
              rows={4}
            ></textarea>
            <label htmlFor="message">Message</label>
          </div>
        );
      }}
    />
  );
};
